import { createFileRoute, Outlet } from '@tanstack/react-router';
import { WorkspaceNoAccess } from '../../../../../../components/settings/no-access';
import { useSession } from '../../../../../../lib/session';

// Workspace settings are admin-only. Anyone else sees the "Only admins can open this page" state in place of the
// page (Figma A16.16) rather than being bounced away, so a pasted link still explains itself.
export const Route = createFileRoute('/subdomain/admin/_staff/settings/workspace')({
  component: WorkspaceGate,
});

function WorkspaceGate() {
  const { data: session } = useSession();
  return session?.user.role === 'admin' ? <Outlet /> : <WorkspaceNoAccess />;
}
